import { isEmpty } from 'lodash';

import { getStorageServices } from '@utils/storage';

const services = getStorageServices();

export const selectServices = (state) =>
  !isEmpty(state.services) ? state.services : services;
